import { render, staticRenderFns } from "./TanUpdate.vue?vue&type=template&id=4fea7d0f&scoped=true&"
import script from "./TanUpdate.vue?vue&type=script&lang=js&"
export * from "./TanUpdate.vue?vue&type=script&lang=js&"
import style0 from "./TanUpdate.vue?vue&type=style&index=0&id=4fea7d0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fea7d0f",
  null
  
)

export default component.exports